import Image from "@/components/AppImage";
import maps from "/public/img/maps.png";
import testimonials_inner_bg from "/public/img/testimonials-inner-bg.png";

const Testimonials = () => {
  return (
    <section className="testimonials-inner">
      <div className="overlay pt-120 pb-120">
        <div className="container">
          <div className="row d-flex justify-content-between">
            <div className="col-lg-5 d-flex justify-content-center">
              <div className="left-area">
                <Image src={testimonials_inner_bg} alt="image" />
              </div>
            </div>
            <div className="col-lg-6 d-flex align-items-center">
              <div className="section">
                <h2 className="title">Freelancers on getting paid globally</h2>
                <h4>Finally, predictable FX</h4>
                <p className="xxlr">
                  I bill EU and US clients weekly. OracleMarket shows the rate upfront,
                  lands funds in my local account fast, and I stopped losing
                  margin to hidden bank fees.
                </p>
                <ul className="d-flex star-area align-items-center">
                  {[...Array(5)].map((_, i) => (
                    <li key={i}>
                      <i className="fas fa-star"></i>
                    </li>
                  ))}
                </ul>
                <div className="name-location d-flex align-items-center">
                  <h6>April Perry</h6>
                  <p className="smr">
                    {" "}
                    <Image src={maps} alt="image" />
                    United Kingdom
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
